import React from 'react';
import {Routes, Route} from "react-router-dom";

//routes
import Landing from './pages/Landing'
import GetStarted from './pages/GetStarted'
import Review from './pages/Review'
import ThankYou from './pages/ThankYou'
import Layout from './layout'

const publicRoutes = [
    {path: "/", component: <Landing/>},
    {path: "/getstarted", component: <GetStarted/>},
    {path: "/review", component: <Review/>},
    {path: "/thankyou", component: <ThankYou/>},
]
const Index = () => {
    return (
        <React.Fragment>
            <Routes>
                {publicRoutes.map((route, idx) => (
                    <Route
                        path={route.path}
                        element={
                            <Layout>
                                {route.component}
                            </Layout>}
                        key={idx}
                        exact={true}
                    />
                ))}
            </Routes>
        </React.Fragment>
    );
};

export default Index;
